import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { Button } from 'ui-components/components/button';
import { MultiPackageModal } from '../../components/modals/multi-package-modal';
import ModalPortal from '../../components/modal-portal';
import { useModal } from '../../hooks/use-modal';
import { useFulfillmentPlannerContext } from '../context';
import style from './package-content-description.module.less';

export const ReadOnlyMessageForMultiPackageConfigs = ({ className }) => {
  const { close, isOpen, open } = useModal();
  const { hasInsuranceProviderSelected, onMultiPackageSave, packages: packagesFromContext } = useFulfillmentPlannerContext();

  const onSave = useCallback(
    (packages) => {
      onMultiPackageSave(packages);
      close();
    },
    [close, onMultiPackageSave],
  );

  return (
    <>
      <div className={classnames(style['read-only-message'], className)}>
        <FormattedMessage
          {...messages.multiPackage}
          values={{
            button: (chunks) => (
              <Button className={style.button} onClick={open} theme='link'>
                {chunks}
              </Button>
            ),
          }}
        />
      </div>
      {isOpen && (
        <ModalPortal onClose={close}>
          <MultiPackageModal
            hasInsuranceProviderSelected={hasInsuranceProviderSelected}
            hasMultiPackageSupport
            initialPackages={packagesFromContext}
            onSave={onSave}
            shouldRequirePackageDescription
          />
        </ModalPortal>
      )}
    </>
  );
};

ReadOnlyMessageForMultiPackageConfigs.propTypes = {
  className: PropTypes.string,
};
